import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    loading: false,
    activo: false,
    data : {},
    fc_40: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        nombrerazonSocial: '',
        telefono: '',
        correoelectronico: '',
        hologramasparamezcal: false,
        cantidadhologramasparamezcal: '',
        hologramasparabebidasconmezcal: false,
        cantidadhologramasparabebidasco: '',
    },
    paginaActiva: 1,
    fc_40Map : {},
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
    modoProceso:false,
    filesMap: [],
}

//types
const ACTUALIZAR_FC_40_PAGINA = 'ACTUALIZAR_FC_40_PAGINA'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const OBTENER_FC_40_DETALLE_EXITO_AT = 'OBTENER_FC_40_DETALLE_EXITO_AT'
const ACTUALIZAR_FC_40_ESTATUS_EXITO = 'ACTUALIZAR_FC_40_ESTATUS_EXITO'
const AGREGAR_FC_40_EXITO_MAP = 'AGREGAR_FC_40_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_40_MAP_EXITOAT = 'OBTENER_FC_40_MAP_EXITOAT'
const AGREGAR_FC_40_EXITO = 'AGREGAR_FC_40_EXITO'
const AGREGAR_FC_40_MAP_EXITO = 'AGREGAR_FC_40_MAP_EXITO'
const ACTUALIZAR_FC_40_EXITO = 'ACTUALIZAR_FC_40_EXITO'
const ACTUALIZAR_FC_35_EXITOAT = 'ACTUALIZAR_FC_35_EXITOAT'
const GENERAR_OFICIOS_FC40_EXITO = 'GENERAR_OFICIOS_FC40_EXITO'
//reducer

export const obtenerFC_40SolicitudDetalle  = createAsyncThunk(
    OBTENER_FC_40_DETALLE_EXITO_AT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_40/obtenerFormatoFC40_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_40Estatus = createAsyncThunk(
    ACTUALIZAR_FC_40_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarMapFC_40Accion = createAsyncThunk(
    AGREGAR_FC_40_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud}
            let archivosMap = data.archivosMap
            const agregarFC_40Map = host + 'MapSolicitud/agregarMapFC_40_Solicitud'
            const agregarFC_40ArchivosMap = host + `MapSolicitud/agregarMapFC_40_ArchivosGenerales`
            const res = await axios.post(agregarFC_40Map, solicitud)

            for (const anexo of archivosMap) {
                await axios.post(agregarFC_40ArchivosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    } 
)

export const obtenerFC_40Map = createAsyncThunk(
    OBTENER_FC_40_MAP_EXITOAT,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_40_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_40/obtenerFormatoFC40_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_40_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_40archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_40archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_40archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}

export const actualizarFC_40Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_40_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivos = data.archivos

            const actualizarFC_40 = host + `FC_40/actualizarFormatoFC40`
            const urlActualizarArchivos = host + 'FC_40/actualizarArchivoFC_40'
            const res = await axios.put(actualizarFC_40, solicitud)

            for (const anexo in archivos) {
                let resAnexo = await axios.put(urlActualizarArchivos, { data: archivos[anexo] })
            }
            //return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_40SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_35_EXITOAT,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosMap = data.archivosMap
            const actualizarFC_40Map = host + `MapSolicitud/actualizarMapFC_40_Solicitud`
            
            const urlAgregarArchivos = host + 'MapSolicitud/agregarMapFC_40_ArchivosGenerales'
            const urlActualizarArchivos = host + 'MapSolicitud/actualizarMapFC_40_ArchivosGenerales'
            const res = await axios.put(actualizarFC_40Map, { data: solicitud.data })
            for (let anexo of archivosMap) {
                if (anexo.idfc_40archivosmap != "" && anexo.idfc_40archivosmap != null && anexo.idfc_40archivosmap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivos, { data: anexo })
                } else {
                    delete anexo.idfc_40archivosmap
                    let resAnexo = await axios.post(urlAgregarArchivos, { data: anexo })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_40 = createAsyncThunk(
    GENERAR_OFICIOS_FC40_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc40Slice = createSlice({
    name: 'fc40Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_40(state,{payload}) {
            state.paginaActiva = payload
        },
        guardarCambiosFC_40Solicitud(state, {payload}) {
            state.fc_40 = payload
        },
        resetDataFC_40(state,{payload}) {
            return dataInicial
        },
        setModoVerDetalleFC_40(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_40(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_40(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [agregarMapFC_40Accion.fulfilled]: (state, {payload}) => {  
        },
        [actualizarFC_40Estatus.fulfilled]: (state, {payload}) => {
        },
        [obtenerFC_40SolicitudDetalle.fulfilled]: (state, {payload}) => {
            state.data = payload
        },
        [obtenerIdCliente.fulfilled]: (state, {payload}) => {
        },
        [obtenerFC_40Map.fulfilled]: (state, { payload }) => {
            state.fc_40Map = payload.data
            state.filesMap = payload.filesMap
        },
        [actualizarFC_40Solicitud.fulfilled]: (state, {payload}) => {
        },
    },
})

//actions
export const {
    actualizarPaginaActivaFC_40, resetDataFC_40,
    guardarCambiosFC_40Solicitud,
    setModoVerDetalleFC_40, setModoRecibidasCorregidasFC_40, setModoProcesoFC_40
    
} = fc40Slice.actions

export const FC40ReducerAtencionACliente = fc40Slice.reducer

